import React, { useEffect, useRef, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import NtactLogo from '../assets/NTACT Logo.svg';
import { Document, Page, Text, View, StyleSheet, Image, PDFViewer } from '@react-pdf/renderer';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import LOgo from '../assets/Ntact.png'
import { Backdrop, CircularProgress } from '@mui/material';
import api from '../api/api';
import { useSelector } from 'react-redux';
import SignatureModal from './Signaturemodal';

import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
import { redcheck } from '../utils/svgs/svgs';
import VehicleCheckTable from './vechilechecktablenative';
dayjs.extend(isoWeek);
const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    paddingHorizontal: 25,
    paddingVertical: 20,
    fontSize: 10,
    fontFamily: "Helvetica",
    display: "flex",
    justifyContent: "flex-start",
  },

  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 10,
    borderBottom: "1px solid #ccc",
    paddingBottom: 6,
  },
  logo: { width: 80, height: 40 },
  title: { fontSize: 18, fontWeight: "bold" },

  grid: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 8,
  },
  gridItem: {
    border: "1px solid #ccc",
    padding: 5,
    width: "32%",
  },

  table: { border: "1px solid #ccc", marginBottom: 8 },
  tableRow: { flexDirection: "row", borderBottom: "1px solid #ccc" },
  tableCell: {
    borderRight: "1px solid #ccc",
    padding: 4,
    flex: 1,
    textAlign: "center",
    fontSize: 9,
  },
  tableHeader: {
    backgroundColor: "#f3f4f6",
    fontWeight: "bold",
  },

  equipmentTag: {
    fontSize: 7,
    fontWeight: "bold",
    backgroundColor: "#FEF3C7",
    color: "#B45309",
    padding: "1 3",
    borderRadius: 2,
  },

  note: {
    border: "1px solid #FECACA",
    backgroundColor: "#FEE2E2",
    padding: 10,
    marginBottom: 8,
    fontSize: 12,
  },

  comments: { border: "1px solid #ccc", padding: 10, marginVertical: 8 },

  signatureGrid: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 10,
  },
  signatureItem: { border: "1px solid #ccc", padding: 6, width: "48%" },
  underline: { borderBottomWidth: 0.5, borderBottomColor: "#ccc", marginVertical: 2 },
});

const PDFDocument = ({
  imagesarray,
  allUnits,
  dates,
  driverName,
  unitNumber,
  filledDate,
    commentsData,
  allDateEntries,
  weekData,
  vehicleComponents,
  logData,
  comments,
  checkedBy,
  dfData,
  dfSignPreviews,
  dfSignOffNotes,
  isAllEmployees,
  employeeSections: empSections,
}) => {
  const buildWeeks = (weekData) => {
  const dates = Object.keys(weekData)
    .filter(d => dayjs(d, "YYYY-MM-DD", true).isValid())
    .sort();

  if (!dates.length) return [];

  const weeks = {};

  dates.forEach(d => {
    const start = dayjs(d).startOf("isoWeek").format("YYYY-MM-DD");
    const end = dayjs(d).endOf("isoWeek").format("YYYY-MM-DD");
    const key = `${start}_${end}`;

    if (!weeks[key]) {
      const fullWeek = [];
      for (let i = 0; i < 7; i++) {
        fullWeek.push(dayjs(start).add(i, "day").format("YYYY-MM-DD"));
      }

      weeks[key] = { start, end, dates: fullWeek };
    }
  });

  return Object.values(weeks);
};

const weeklyTables = buildWeeks(weekData);
  // 🗓 Generate full week dates
  const getFullWeekDates = (weekData) => {
    const dates = Object.keys(weekData).sort();
    if (!dates.length) return [];
    const start = dayjs(dates[0]).startOf("isoWeek");
    const fullWeek = [];
    for (let i = 0; i < 7; i++) {
      fullWeek.push(start.add(i, "day").format("YYYY-MM-DD"));
    }
    return fullWeek;
  };

  const fullWeekDates = getFullWeekDates(weekData);

  const renderEmployeePages = (sec) => {
    const secWeeklyTables = buildWeeks(sec.weekData);
    const secAllUnits = sec.formsData.map(f => ({ unit: f.unitNumber, fuel: f.fuelAllocation, date: f.filledDate }));

    const renderLogRows = (ld) => {
      if (ld.length === 0) {
        return (
          <View style={[styles.tableRow, { borderWidth: 1, borderColor: "#ccc" }]}>
            <Text style={[styles.tableCell, { flex: 8 }]}>No log data available</Text>
          </View>
        );
      }
      const dateGroups = [];
      ld.forEach((log) => {
        const last = dateGroups[dateGroups.length - 1];
        if (last && last[0].date === log.date) { last.push(log); } else { dateGroups.push([log]); }
      });
      return dateGroups.map((group, gIndex) => {
        const first = group[0];
        if (group.length === 1) {
          const isEquip = first.fuel_allocation === 'equipment';
          return (
            <View key={gIndex} wrap={false} style={[styles.tableRow, { borderWidth: 1, borderColor: "#ccc", marginTop: -1 }]}>
              <Text style={styles.tableCell}>{first.date}</Text>
              <Text style={styles.tableCell}>{first.mileage_start}</Text>
              <Text style={styles.tableCell}>{first.mileage_end}</Text>
              <Text style={styles.tableCell}>{isEquip ? '—' : first.job_number}</Text>
              <Text style={styles.tableCell}>
                {isEquip ? (<><Text style={styles.equipmentTag}>EQUIPMENT  </Text>{first.equipment_description || '-'}</>) : first.repair_fillup_location}
              </Text>
              <Text style={styles.tableCell}>{first.gallons_fuel}</Text>
              <Text style={styles.tableCell}>{first.total_amount}</Text>
              <Text style={styles.tableCell}>{isEquip ? '—' : first.mileage_at_repair_fillup}</Text>
            </View>
          );
        }
        return (
          <View key={gIndex} wrap={false} style={[styles.tableRow, { borderWidth: 1, borderColor: "#ccc", marginTop: -1 }]}>
            <View style={[styles.tableCell, { justifyContent: 'center' }]}><Text>{first.date}</Text></View>
            <View style={[styles.tableCell, { justifyContent: 'center' }]}><Text>{first.mileage_start}</Text></View>
            <View style={[styles.tableCell, { justifyContent: 'center' }]}><Text>{first.mileage_end}</Text></View>
            <View style={{ flex: 5 }}>
              {group.map((log, rIndex) => {
                const isEquip = log.fuel_allocation === 'equipment';
                return (
                  <View key={rIndex} style={[{ flexDirection: 'row' }, rIndex < group.length - 1 && { borderBottom: '1px solid #ccc' }].filter(Boolean)}>
                    <Text style={styles.tableCell}>{isEquip ? '—' : log.job_number}</Text>
                    <Text style={styles.tableCell}>
                      {isEquip ? (<><Text style={styles.equipmentTag}>EQUIPMENT  </Text>{log.equipment_description || '-'}</>) : log.repair_fillup_location}
                    </Text>
                    <Text style={styles.tableCell}>{log.gallons_fuel}</Text>
                    <Text style={styles.tableCell}>{log.total_amount}</Text>
                    <Text style={styles.tableCell}>{isEquip ? '—' : log.mileage_at_repair_fillup}</Text>
                  </View>
                );
              })}
            </View>
          </View>
        );
      });
    };

    return (
      <Page size="A4" orientation="landscape" style={styles.page}>
        {/* Header */}
        <View style={styles.header} wrap={false}>
          <Image src={LOgo} style={styles.logo} />
          <Text style={styles.title}>WEEKLY DRIVER LOG & SAFETY</Text>
          <View style={{ width: 70 }} />
        </View>

        {/* Driver Info */}
        <View style={styles.grid} wrap={false}>
          <View style={styles.gridItem}>
            <Text style={{ fontWeight: "bold" }}>Driver:</Text>
            <Text>{sec.driverName}</Text>
            <View style={styles.underline} />
          </View>
          <View style={styles.gridItem}>
            <Text style={{ fontWeight: "bold" }}>Date:</Text>
            <Text>{sec.dates}</Text>
            <View style={styles.underline} />
          </View>
          <View style={styles.gridItem} />
        </View>

        {/* Unit Info */}
        <View style={{ marginBottom: 6 }}>
          {secAllUnits.map((item, i) => (
            <View key={i} wrap={false} style={{ flexDirection: "row", borderWidth: 1, borderColor: "#000", marginTop: i === 0 ? 0 : -1 }}>
              <View style={{ width: "40%", padding: 5, borderRightWidth: 1, borderColor: "#000" }}>
                <Text style={{ fontSize: 9, fontWeight: "bold" }}>Date</Text>
                <Text style={{ fontSize: 11 }}>{item.date}</Text>
              </View>
              <View style={{ width: "60%", padding: 5 }}>
                <Text style={{ fontSize: 9, fontWeight: "bold" }}>Unit #</Text>
                <Text style={{ fontSize: 11 }}>{item.unit}</Text>
              </View>
            </View>
          ))}
        </View>

        {/* Log Table */}
        <View style={{ marginBottom: 8 }}>
          <View style={[styles.tableRow, styles.tableHeader, { borderWidth: 1, borderColor: "#ccc" }]}>
            <Text style={styles.tableCell}>Date</Text>
            <Text style={styles.tableCell}>Mileage Start</Text>
            <Text style={styles.tableCell}>Mileage End</Text>
            <Text style={styles.tableCell}>Job #</Text>
            <Text style={styles.tableCell}>Repair/Fill-up Location</Text>
            <Text style={styles.tableCell}>Gallons Fuel</Text>
            <Text style={styles.tableCell}>Total Amount</Text>
            <Text style={styles.tableCell}>Mileage @ Repair/Fill-up</Text>
          </View>
          {renderLogRows(sec.logData)}
        </View>

        {/* Note */}
        <View style={styles.note} wrap={false}>
          <Text style={{ fontSize: 11 }}>
            NOTE: Seat belts shall be worn any time the vehicle is in motion. This log shall be kept current and turned in weekly.
          </Text>
        </View>

        {/* Vehicle Safety Check */}
        <Text break style={{ marginVertical: 6, fontWeight: "bold", fontSize: 15 }}>Vehicle Safety Check</Text>
        <Text style={{ fontSize: 12, marginBottom: 8 }}>Check YES for good condition, NO if item requires attention (add comment)</Text>

        {secWeeklyTables.map((week, wIndex) => (
          <View key={wIndex} break={wIndex > 0} style={{ marginBottom: 10 }}>
            <Text style={{ fontSize: 13, fontWeight: "bold", marginBottom: 6 }}>
              Week: {dayjs(week.start).format("MMM DD")} - {dayjs(week.end).format("MMM DD")}
            </Text>
            <VehicleCheckTable
              fullWeekDates={week.dates}
              allDateEntries={sec.allDateEntries}
              weekData={sec.weekData}
              vehicleComponents={VEHICLE_COMPONENTS_LIST}
            />
          </View>
        ))}

        {/* Comments */}
        {sec.commentsData?.length > 0 && (
          <View style={styles.comments}>
            <Text style={{ fontWeight: "bold", marginBottom: 6, fontSize: 14 }}>
              COMMENTS - {sec.driverName}
            </Text>
            {sec.commentsData.map((c, i) => (
              <View key={i} style={{ marginBottom: 6 }}>
                <Text style={{ fontSize: 12, color: "#555" }}>{dayjs(c.date).format("MMM DD, YYYY")}</Text>
                <Text style={{ fontSize: 12 }}>{c.comment}</Text>
              </View>
            ))}
          </View>
        )}
      </Page>
    );
  };

  return (
    <Document>
      {isAllEmployees ? (
        empSections.map((sec, sIndex) => (
          <React.Fragment key={sIndex}>
            {renderEmployeePages(sec)}
          </React.Fragment>
        ))
      ) : (
        <>
          {renderEmployeePages(empSections[0])}
        </>
      )}

      {/* ===== SHARED: IMAGES + SIGNATURES ===== */}
      <Page size={{ width: 842, height: 680 }} style={styles.page}>
        {/* Comment Images by Date */}
        {imagesarray?.commentImagesByDate &&
          Object.keys(imagesarray.commentImagesByDate).length > 0 && (
            <View style={{ marginTop: 10 }}>
              <Text style={{ fontWeight: "bold", marginBottom: 6, fontSize: 14 }}>
                COMMENT IMAGES (BY DATE)
              </Text>

              {Object.entries(imagesarray.commentImagesByDate).map(([date, imgs], idx) => (
                <View key={idx} style={{ marginBottom: 14 }}>
                  <Text style={{ fontSize: 12, fontWeight: "bold", marginBottom: 4 }}>
                    {dayjs(date).format("MMM DD, YYYY")}
                  </Text>

                  <Text style={{ fontSize: 9, marginBottom: 4, textDecoration: "underline" }}>
                    Comment Images:
                  </Text>

                  <View style={{ flexDirection: "row", flexWrap: "wrap", gap: 10, marginBottom: 8 }}>
                    {imgs.map((img, i) => (
                      <View
                        key={i}
                        style={{
                          width: 180,
                          height: 120,
                          borderWidth: 1,
                          borderColor: "#D1D5DB",
                          borderRadius: 4,
                          marginRight: 8,
                          marginBottom: 8,
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {img?.base64_data && (
                          <Image
                            src={img.base64_data}
                            style={{ width: 170, height: 110, objectFit: "contain" }}
                          />
                        )}
                      </View>
                    ))}
                  </View>
                </View>
              ))}
            </View>
          )}

        {/* Signatures - flows right after images, no page break */}
        <View style={{ marginTop: 20 }}>
          <Text style={{ fontWeight: "bold", fontSize: 14, marginBottom: 12, textAlign: "center" }}>
            VERIFICATION & SIGNATURES
          </Text>

          <View style={styles.signatureGrid}>
            <View style={[styles.signatureItem, { minHeight: 80, padding: 10 }]}>
              <Text style={{ fontWeight: "bold", fontSize: 13 }}>Checked By:</Text>
              <Text style={{ fontSize: 12, marginTop: 6 }}>{checkedBy}</Text>
              <View style={[styles.underline, { marginTop: 8 }]} />
            </View>

            <View style={[styles.signatureItem, { minHeight: 80, padding: 10 }]}>
              <Text style={{ fontWeight: "bold", fontSize: 13 }}>Driver Signature:</Text>
              {imagesarray?.driverSignature?.base64_data && (
                <Image
                  src={imagesarray.driverSignature.base64_data}
                  style={{
                    width: 160,
                    height: 70,
                    objectFit: "contain",
                    borderWidth: 1,
                    borderColor: "#D1D5DB",
                    borderRadius: 3,
                    marginTop: 6,
                  }}
                />
              )}
              <View style={[styles.underline, { marginTop: 8 }]} />
            </View>
          </View>
        </View>

        {/* DF Sign-Off Section */}
        {dfData && Object.keys(dfData).length > 0 && (
          <View style={{ border: '1px solid #ccc', padding: 10, marginTop: 12 }}>
            <Text style={{ fontWeight: 'bold', fontSize: 13, marginBottom: 8 }}>Driver Form Sign-Off</Text>
            {Object.entries(dfData).map(([userId, entry]) => {
              const entryName = typeof entry === 'object' ? entry?.name : '';
              const sigUri = dfSignPreviews?.[userId];
              const notes = dfSignOffNotes?.[userId];
              return (
                <View key={userId} style={{ borderBottom: '1px solid #eee', paddingBottom: 8, marginBottom: 8 }}>
                  <Text style={{ fontSize: 11, fontWeight: 'bold' }}>
                    {entryName || `User #${userId}`}
                  </Text>
                  {sigUri && (
                    <Image
                      source={{ uri: sigUri }}
                      style={{
                        width: 120,
                        height: 40,
                        resizeMode: 'contain',
                        borderWidth: 1,
                        borderColor: '#D1D5DB',
                        borderRadius: 4,
                        backgroundColor: '#fff',
                        marginTop: 4,
                      }}
                    />
                  )}
                  {notes ? (
                    <View style={{ marginTop: 4 }}>
                      <Text style={{ fontSize: 9, fontWeight: 'bold', color: '#555' }}>Notes:</Text>
                      <Text style={{ fontSize: 9, color: '#333' }}>{notes}</Text>
                    </View>
                  ) : null}
                  <Text style={{ fontSize: 9, color: '#16a34a', marginTop: 3 }}>Signed Off</Text>
                </View>
              );
            })}
          </View>
        )}

      </Page>
    </Document>
  );
};

 {/* <View style={styles.signatureGrid}>
          <View style={styles.signatureItem}>
            <Text style={{ fontWeight: "bold" }}>Checked By:</Text>
            <Text>{checkedBy}</Text>
            <View style={styles.underline} />
          </View>
          <View style={styles.signatureItem}>
            <Text style={{ fontWeight: "bold" }}>Driver Signature:</Text>
            {imagesarray?.[0]?.base64_data && (
              <Image
                source={{ uri: imagesarray[0].base64_data }}
                style={{
                  width: 120,
                  height: 60,
                  resizeMode: "contain",
                  borderWidth: 1,
                  borderColor: "#D1D5DB",
                  borderRadius: 2,
                  marginTop: 3,
                }}
              />
            )}
            <View style={styles.underline} />
          </View>
        </View> */}
const VEHICLE_COMPONENTS_LIST = [
  "ACCIDENT FORM", "BATTERY", "BELTS", "BRAKE FLUID", "ENGINE OIL",
  "FIRE EXTINGUISHER (10lb)", "FIRST AID KIT", "HEADLAMPS & HI-BEAMS",
  "HEATER HOSES", "HITCH, RECEIVER, AND PINS", "HORN", "INSURANCE CARD",
  "JACK & TIRE IRON", "LIGHTS (Parking & BRAKE)", "MIRRORS", "PARKING BRAKE",
  "RADIATOR FLUID", "RADIATOR HOSES", "SEATBELTS", "SPARE TIRE",
  "STEERING FLUID", "TIRE PSI", "TRANSMISSION OIL", "TURN SIGNALS",
  "WASHER FLUID", "WINDSHIELD WIPERS"
];

const buildWeeksHelper = (wd) => {
  const dates = Object.keys(wd).filter(d => dayjs(d, "YYYY-MM-DD", true).isValid()).sort();
  if (!dates.length) return [];
  const weeks = {};
  dates.forEach(d => {
    const start = dayjs(d).startOf("isoWeek").format("YYYY-MM-DD");
    const end = dayjs(d).endOf("isoWeek").format("YYYY-MM-DD");
    const key = `${start}_${end}`;
    if (!weeks[key]) {
      const fullWeek = [];
      for (let i = 0; i < 7; i++) fullWeek.push(dayjs(start).add(i, "day").format("YYYY-MM-DD"));
      weeks[key] = { start, end, dates: fullWeek };
    }
  });
  return Object.values(weeks);
};

const computeEmployeeData = (forms) => {
  const driverName = forms[0]?.emp_name || 'N/A';
  const empId = forms[0]?.emp_id || '';
  const unitNumber = forms[0]?.json_data?.find(q => q.question === "Driver Information - Unit Number")?.answer || 'N/A';

  const weekData = {};
  forms.forEach(report => {
    const date = dayjs(report.filled_date).isValid() ? dayjs(report.filled_date).format("YYYY-MM-DD") : null;
    if (!date) return;
    const compMap = {};
    (report.json_data || []).forEach(q => {
      if (q?.question?.includes("Vehicle Safety Check")) {
        const component = q.question.split(" - ").pop().trim();
        compMap[component] = q.answer?.toUpperCase().startsWith("Y") ? "Y" : "N";
      }
    });
    if (!weekData[date]) weekData[date] = [];
    weekData[date].push(compMap);
  });

  const allDateEntries = [];
  Object.keys(weekData).sort().forEach(date => {
    const entries = weekData[date]?.filter(d => d && Object.keys(d).length > 0);
    if (entries?.length > 0) entries.forEach((data, idx) => allDateEntries.push({ date, idx, data }));
  });

  const sortedForms = [...forms].sort((a, b) => new Date(a.filled_date) - new Date(b.filled_date));
  const formsData = sortedForms.map(form => ({
    unitNumber: form?.json_data?.find(q => q.question === "Driver Information - Unit Number")?.answer || "N/A",
    fuelAllocation: form?.json_data?.find(q => q.question === "Driver Information - Fuel Allocation")?.answer || "N/A",
    filledDate: form?.filled_date || "N/A",
  }));

  const filledDates = sortedForms.map(f => f.filled_date).filter(Boolean);
  const dates = filledDates.length > 1
    ? `${filledDates[0]} - ${filledDates[filledDates.length - 1]}`
    : filledDates[0] || 'N/A';

  const logData = forms.flatMap(entry => {
    const filledDate = entry.filled_date || "N/A";
    const driverLogs = entry?.json_data?.find(item => item.question === "Driver Log Entries")?.answer;
    if (!driverLogs || !Array.isArray(driverLogs)) return [];
    return driverLogs.flatMap(log => {
      const legacyEntryAlloc = log.fuelAllocation === 'equipment' ? 'equipment' : 'vehicle';
      let fillUps = [];
      if (Array.isArray(log.fillUps) && log.fillUps.length > 0) {
        fillUps = log.fillUps.map(f => ({
          location: f.location || "", gallons: f.gallons || "",
          amount: f.amount ?? f.totalAmount ?? "", mileage: f.mileage ?? f.mileageAtRepair ?? "",
          equipmentDescription: f.equipmentDescription || "",
          fuelAllocation: f.fuelAllocation === 'equipment' ? 'equipment' : f.fuelAllocation === 'vehicle' ? 'vehicle' : legacyEntryAlloc,
        }));
      } else if (log.location || log.gallons || log.amount || log.mileage) {
        fillUps = [{ location: log.location || "", gallons: log.gallons || "", amount: log.amount || "", mileage: log.mileage || "", equipmentDescription: log.equipmentDescription || "", fuelAllocation: legacyEntryAlloc }];
      }
      const baseRow = { date: filledDate, mileage_start: log.Start || "N/A", mileage_end: log.End || "N/A", job_number: log.Job || "N/A" };
      if (fillUps.length === 0) {
        return [{ ...baseRow, repair_fillup_location: "N/A", gallons_fuel: "N/A", total_amount: "N/A", mileage_at_repair_fillup: "N/A" }];
      }
      return fillUps.map((f, i) => {
        const fuAlloc = f.fuelAllocation || 'vehicle';
        return {
          ...baseRow, fuel_allocation: fuAlloc,
          equipment_description: fuAlloc === 'equipment' ? (f.equipmentDescription || '') : '',
          mileage_start: i === 0 ? baseRow.mileage_start : "", mileage_end: i === 0 ? baseRow.mileage_end : "",
          job_number: i === 0 ? baseRow.job_number : "",
          repair_fillup_location: fuAlloc === 'equipment' ? "" : (f.location || "N/A"),
          gallons_fuel: f.gallons || "N/A", total_amount: f.amount || "N/A",
          mileage_at_repair_fillup: fuAlloc === 'equipment' ? "" : (f.mileage || "N/A"),
        };
      });
    });
  }) || [];

  const commentsData = forms.flatMap(entry => {
    const comment = entry?.json_data?.find(item => item.question === "Comments")?.answer;
    if (!comment || !comment.trim()) return [];
    return [{ date: entry.filled_date, comment: comment.trim() }];
  });

  const checkedBy = forms[0]?.json_data?.find(item => item.question === "Checked By")?.answer || 'N/A';
  const weeklyTables = buildWeeksHelper(weekData);

  return { driverName, empId, unitNumber, dates, formsData, logData, weekData, weeklyTables, allDateEntries, commentsData, checkedBy };
};

const WDSMergeFormModal = ({ setFormView, rowData, handleDfSignOff }) => {
     const [loader,setLoader]=useState(false)
  const formRef = useRef(null);
 console.log(rowData,'roww')
  const [pdfBlob, setPdfBlob] = useState(null);
    const [imagesarray,setImagesArray]=useState([])

  // DF (Driver Form) sign-off state
  const user = useSelector((state) => state.user.userDetails);
  const [df_data, setDfData] = useState(rowData?.df_data || {});
  const [dfStatus, setDfStatus] = useState(rowData?.df_status || 'N');
  const [dfSignPreviews, setDfSignPreviews] = useState({});
  const [dfSignatureModalOpen, setDfSignatureModalOpen] = useState(false);
  const [dfSignOffNote, setDfSignOffNote] = useState('');
  const dfSignOffNotesFromServer = rowData?.df_sign_off_notes || {};
  const hasN2 = user?.user_info?.permissions?.includes('N2');
  const currentUserSigned = df_data && df_data[String(user?.id)]?.status === 'Y';
  const needsSignOff = dfStatus === 'P' || dfStatus === 'Y';

  const handleStartDfSignOff = () => {
    setDfSignatureModalOpen(true);
  };

  const handleDfSignatureCapture = async (file) => {
    if (!file || !user?.id || !rowData?.id) return;
    setDfSignatureModalOpen(false);
    try {
      setLoader(true);
      const fd = new FormData();
      fd.append('files', file);
      const uploadResp = await api.post('/v1/forms/upload-files', fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      const uploaded = uploadResp?.files?.[0];
      const uploadedFileName = uploaded?.file_name || uploaded?.fileName || uploaded;
      if (!uploadedFileName) throw new Error('Signature upload failed');

      const userName = user?.firstname
        ? `${user.firstname}${user.lastname ? ' ' + user.lastname : ''}`
        : user?.email || '';
      const res = await api.post(`/v1/forms/${rowData.id}/update-df-sign`, {
        user_id: user.id,
        user_name: userName,
        df_sign: uploadedFileName,
        df_status: 'Y',
        sign_off_notes: dfSignOffNote || '',
      });

      if (res?.status === 200) {
        setDfData((prev) => ({
          ...prev,
          [String(user.id)]: { name: userName, status: 'Y' },
        }));
        setDfStatus('Y');
        const localPreview = URL.createObjectURL(file);
        setDfSignPreviews((prev) => ({ ...prev, [user.id]: localPreview }));
        if (typeof handleDfSignOff === 'function') {
          try { handleDfSignOff(rowData, user.id, { skipApi: true }); } catch (e) {}
        }
      }
    } catch (err) {
      console.error('DF Sign off failed:', err);
    } finally {
      setLoader(false);
    }
  };

  const fetchDfSignature = async (userId) => {
    const cacheBuster = new Date().getTime();
    const canonicalUrl = `https://hub2.ntactops.com/ntact/files/forms_files/${rowData.id}_${userId}_dfsign.png?cb=${cacheBuster}`;
    try {
      const response = await api.post("/v1/images/to-base64", { image_url: canonicalUrl });
      if (response.status === 200 && response.data?.base64) {
        setDfSignPreviews((prev) => ({
          ...prev,
          [userId]: `data:image/png;base64,${response.data.base64}`,
        }));
      }
    } catch (err) {
      console.log("No DF signature for user:", userId);
    }
  };

  useEffect(() => {
    if (!df_data) return;
    Object.entries(df_data).forEach(([userId, entry]) => {
      const isSigned = typeof entry === 'object' ? entry?.status === 'Y' : entry === 'Y';
      if (isSigned) fetchDfSignature(userId);
    });
  }, [df_data]);
    const weekreport=rowData.json_data

  const isAllEmployees = rowData.json_data?.some(obj => obj.allEmployees);
  const employeeSections = (() => {
    const wdsForms = weekreport.filter(r => r.form_type === "WDS");
    if (isAllEmployees) {
      const grouped = {};
      wdsForms.forEach(form => {
        const key = `${form.emp_name}_${form.emp_id}`;
        if (!grouped[key]) grouped[key] = [];
        grouped[key].push(form);
      });
      return Object.values(grouped).map(forms => computeEmployeeData(forms));
    }
    return [computeEmployeeData(wdsForms)];
  })();

    // Preprocess weekreport into a structure: { date: { component: "Y/N" } }
  const weekData = {};

weekreport.forEach((report) => {
const date = dayjs(report.filled_date).isValid()
  ? dayjs(report.filled_date).format("YYYY-MM-DD")
  : null;

if (!date) return; // skip invalid

  const compMap = {};
  (report.json_data || []).forEach((q) => {
    if (q?.question && q.question.includes("Vehicle Safety Check")) {
      const component = q.question.split(" - ").pop().trim();
      const answer = q.answer?.toUpperCase().startsWith("Y") ? "Y" : "N";
      compMap[component] = answer;
    }
  });

  if (!weekData[date]) weekData[date] = [];
  weekData[date].push(compMap);
});


  // Step 2: Ordered list of vehicle components
  const vehicleComponents = [
    "ACCIDENT FORM", "BATTERY", "BELTS", "BRAKE FLUID", "ENGINE OIL",
    "FIRE EXTINGUISHER (10lb)", "FIRST AID KIT", "HEADLAMPS & HI-BEAMS",
    "HEATER HOSES", "HITCH, RECEIVER, AND PINS", "HORN", "INSURANCE CARD",
    "JACK & TIRE IRON", "LIGHTS (Parking & BRAKE)", "MIRRORS", "PARKING BRAKE",
    "RADIATOR FLUID", "RADIATOR HOSES", "SEATBELTS", "SPARE TIRE",
    "STEERING FLUID", "TIRE PSI", "TRANSMISSION OIL", "TURN SIGNALS",
    "WASHER FLUID", "WINDSHIELD WIPERS"
  ];

  // Step 3: Flatten dates with indexes → [ {date, idx, data} ]
const allDateEntries = [];
Object.keys(weekData)
  .sort()
  .forEach((date) => {
    const entries = weekData[date]?.filter(d => d && Object.keys(d).length > 0);
    if (entries && entries.length > 0) {
      entries.forEach((data, idx) => {
        allDateEntries.push({ date, idx, data });
      });
    }
  });


    console.log(allDateEntries,'dates')
  // Extract relevant data from rowData
  const driverName = rowData?.emp_name || 'N/A';
  const unitNumber =
     rowData?.json_data[0]?.json_data?.find((item) => item.question === 'Driver Information - Unit Number')?.answer || 'N/A';
  const filledDate = rowData?.filled_date || 'N/A';
const formsData =
  rowData?.json_data
    ?.filter(item => item.form_type === "WDS")   // only real forms
    ?.sort((a, b) => new Date(a.filled_date) - new Date(b.filled_date))
    ?.map(form => {
      const unitNumber =
        form?.json_data?.find(
          q => q.question === "Driver Information - Unit Number"
        )?.answer || "N/A";

      const fuelAllocation =
        form?.json_data?.find(
          q => q.question === "Driver Information - Fuel Allocation"
        )?.answer || "N/A";

      const filledDate = form?.filled_date || "N/A";

      return { unitNumber, fuelAllocation, filledDate };
    }) || [];

  // ✅ Build logData from ALL rows, not just index 0
const logData =
  rowData?.json_data
    ?.flatMap((entry) => {
      const filledDate = entry.filled_date || "N/A";
      const driverLogs = entry?.json_data?.find(
        (item) => item.question === "Driver Log Entries"
      )?.answer;

      if (!driverLogs || !Array.isArray(driverLogs)) return [];

      // Each log entry can carry multiple fill-up stops (`fillUps[]`). Expand
      // them into one row each; the first row keeps the mileage/job, the rest
      // are continuation rows. Falls back to the legacy flat fields.
      return driverLogs.flatMap((log) => {
        // Legacy data may have entry-level fuelAllocation; new data per fill-up.
        const legacyEntryAlloc = log.fuelAllocation === 'equipment' ? 'equipment' : 'vehicle';
        let fillUps = [];
        if (Array.isArray(log.fillUps) && log.fillUps.length > 0) {
          fillUps = log.fillUps.map((f) => ({
            location: f.location || "",
            gallons: f.gallons || "",
            amount: f.amount ?? f.totalAmount ?? "",
            mileage: f.mileage ?? f.mileageAtRepair ?? "",
            equipmentDescription: f.equipmentDescription || "",
            fuelAllocation:
              f.fuelAllocation === 'equipment' ? 'equipment'
              : f.fuelAllocation === 'vehicle' ? 'vehicle'
              : legacyEntryAlloc,
          }));
        } else if (log.location || log.gallons || log.amount || log.mileage) {
          fillUps = [{
            location: log.location || "",
            gallons: log.gallons || "",
            amount: log.amount || "",
            mileage: log.mileage || "",
            equipmentDescription: log.equipmentDescription || "",
            fuelAllocation: legacyEntryAlloc,
          }];
        }

        const baseRow = {
          date: filledDate,
          mileage_start: log.Start || "N/A",
          mileage_end: log.End || "N/A",
          job_number: log.Job || "N/A",
        };

        if (fillUps.length === 0) {
          return [{
            ...baseRow,
            repair_fillup_location: "N/A",
            gallons_fuel: "N/A",
            total_amount: "N/A",
            mileage_at_repair_fillup: "N/A",
          }];
        }

        return fillUps.map((f, i) => {
          const fuAlloc = f.fuelAllocation || 'vehicle';
          return {
            ...baseRow,
            fuel_allocation: fuAlloc,
            equipment_description: fuAlloc === 'equipment' ? (f.equipmentDescription || '') : '',
            mileage_start: i === 0 ? baseRow.mileage_start : "",
            mileage_end: i === 0 ? baseRow.mileage_end : "",
            job_number: i === 0 ? baseRow.job_number : "",
            repair_fillup_location: fuAlloc === 'equipment' ? "" : (f.location || "N/A"),
            gallons_fuel: f.gallons || "N/A",
            total_amount: f.amount || "N/A",
            mileage_at_repair_fillup: fuAlloc === 'equipment' ? "" : (f.mileage || "N/A"),
          };
        });
      });
    }) || [];


  // Extract safety checks
  const safetyChecks = {};
  rowData?.json_data[0]?.json_data
    ?.filter((item) => item.question.includes('Vehicle Safety Check'))
    ?.forEach((item) => {
      const checkName = item.question
        .replace(' Vehicle Safety Check (Part-1) - ', '')
        .replace(' Vehicle Safety Check (Part-2) - ', '')
        .trim();
      safetyChecks[checkName] = item.answer;
    });
const fetchImages = async () => {
  try {
    console.log("%c🟢 Starting fetchImages...", "color: green; font-weight: bold;");
    setLoader(true);

    const allImagesByDate = {};
    let signatureFetched = false;
    let driverSignatureImage = null;

    console.log("📦 weekreport count:", weekreport?.length || 0);

    for (const [rIndex, report] of weekreport.entries()) {
      const reportDate = report.filled_date;
      console.log(`\n📅 Processing report [${rIndex}] - filled_date: ${reportDate}`);

      if (!Array.isArray(report.json_data)) {
        console.warn(`⚠️ report[${rIndex}] has no valid json_data`);
        continue;
      }

      // 🧠 Detect if nested
      const hasNested = report.json_data.some(item => Array.isArray(item?.json_data));
      console.log(`🔎 report[${rIndex}] hasNested:`, hasNested);

      // 🧱 Flatten if nested
      const allForms = hasNested
        ? report.json_data.flatMap(item => (Array.isArray(item.json_data) ? item.json_data : []))
        : report.json_data;

      console.log(`📄 Normalized forms count for report[${rIndex}]:`, allForms.length);

      const date =
        hasNested && report.json_data.find(i => i.filled_date)?.filled_date
          ? report.json_data.find(i => i.filled_date).filled_date
          : reportDate || "Unknown Date";

      console.log(`🗓️ Using date: ${date}`);

      // 🧩 Extract signature & comment images
      const driverSig = allForms.find(q => q.question === "Signature")?.answer || [];
      const commentImgs =
        allForms.find(q => q.question === "Comments - Uploaded Images"||q.question==='Upload Images')?.answer || [];

      console.log(`✍️ Signature found:`, driverSig);
      console.log(`💬 Comment images found:`, commentImgs);

      const filenames = [];

      // Signature (only once globally)
      if (!signatureFetched && driverSig?.[0]?.file_name) {
        filenames.push(driverSig[0].file_name);
        console.log(`✅ Added driver signature filename: ${driverSig[0].file_name}`);
        signatureFetched = true;
      }

      // Comment images
      if (Array.isArray(commentImgs)) {
        commentImgs.forEach(img => {
          if (img?.file_name) {
            filenames.push(img.file_name);
            console.log(`✅ Added comment image filename: ${img.file_name}`);
          }
        });
      }

      if (filenames.length === 0) {
        console.log(`⚠️ No filenames found for date ${date}`);
        continue;
      }

      console.log(`📤 Fetching ${filenames.length} image(s) for date ${date}...`, filenames);

      const queryParams = filenames.map(n => `filenames=${encodeURIComponent(n)}`).join("&");
      const response = await api.get(`/v1/documents/view-multiple?${queryParams}`);
      const apiImages = response?.images || [];

      console.log(`📥 API Response for ${date}:`, response);
      console.log(`🧩 Extracted ${apiImages.length} image(s)`);

      if (response.status === 200 && Array.isArray(apiImages)) {
        const ordered = filenames.map(name =>
          apiImages.find(img => img.filename === name) || null
        );

        console.log(`🧮 Ordered images:`, ordered);

        // Store signature globally
        if (!driverSignatureImage && driverSig?.[0]?.file_name) {
          driverSignatureImage = ordered.find(
            img => img?.filename === driverSig[0].file_name
          );
          console.log("✍️ Stored driver signature globally.");
        }

        // Filter only comment images
        const commentImageArray = Array.isArray(commentImgs)
          ? ordered.filter(img =>
              commentImgs.some(ci => ci.file_name === img?.filename)
            )
          : [];

        console.log(
          `💬 Found ${commentImageArray.length} comment image(s) for ${date}:`,
          commentImageArray.map(i => i?.filename)
        );

        if (!allImagesByDate[date]) allImagesByDate[date] = [];
        allImagesByDate[date].push(...commentImageArray);
      }
    }

    setImagesArray({
      driverSignature: driverSignatureImage,
      commentImagesByDate: allImagesByDate,
    });

    console.log("%c✅ Final fetched data:", "color: lime; font-weight: bold;");
    console.log("Driver Signature:", driverSignatureImage);
    console.table(
      Object.entries(allImagesByDate).flatMap(([d, imgs]) =>
        imgs.map(i => ({ Date: d, Filename: i?.filename }))
      )
    );
  } catch (error) {
    console.error("❌ Error fetching images:", error);
    setImagesArray({ driverSignature: null, commentImagesByDate: {} });
  } finally {
    setLoader(false);
    console.log("%c🔵 fetchImages completed.", "color: blue; font-weight: bold;");
  }
};



useEffect(() => {

    fetchImages();

}, []);
  // Extract comments
  const comments =   rowData?.json_data[0]?.json_data.find((item) => item.question === 'Comments')?.answer || 'No comments provided.';
const commentsData =
  rowData?.json_data?.flatMap((entry) => {
    const date = entry.filled_date;

    const comment =
      entry?.json_data?.find(
        (item) => item.question === "Comments"
      )?.answer;

    // ❌ Skip if no real value
    if (!comment || !comment.trim()) return [];

    return [{
      date,
      comment: comment.trim()
    }];
  }) || [];
  // Extract checked by and signature
  const checkedBy =   rowData?.json_data[0]?.json_data?.find((item) => item.question === 'Checked By')?.answer || 'N/A';
  const driverSignature =   rowData?.json_data[0]?.json_data?.find((item) => item.question === 'Signature')?.answer || 'N/A';
console.log(driverSignature)

  const generatePDF = async () => {
    try {
      setLoader(true);
            const allUnits =
  rowData?.json_data
    ?.filter(f => f.form_type === "WDS")
    ?.map(form => {
      const unit =
        form?.json_data?.find(
          q => q.question === "Driver Information - Unit Number"
        )?.answer || "N/A";

      const fuel =
        form?.json_data?.find(
          q => q.question === "Driver Information - Fuel Allocation"
        )?.answer || "N/A";

      const date = form?.filled_date || "N/A";

      return { unit, fuel, date };
    }) || [];
      const blob = await import('@react-pdf/renderer').then(({ pdf }) =>
        pdf(
          <PDFDocument
            imagesarray={imagesarray}
            driverName={driverName}
            unitNumber={unitNumber}
            filledDate={filledDate}
            logData={logData}
              commentsData={commentsData}
            safetyChecks={safetyChecks}
            comments={comments}
            checkedBy={checkedBy}
            driverSignature={driverSignature}
            weekData={weekData}
            vehicleComponents={vehicleComponents}
allDateEntries={allDateEntries}
dates={rowData.json_data?.find(obj => obj.Dates)?.Dates ||filledDate}
allUnits={allUnits}
            dfData={df_data}
            dfSignPreviews={dfSignPreviews}
            dfSignOffNotes={dfSignOffNotesFromServer}
            isAllEmployees={isAllEmployees}
            employeeSections={employeeSections}
          />
        ).toBlob()
      );
      setPdfBlob(blob);
      const pdfUrl = URL.createObjectURL(blob);
      window.open(pdfUrl, '_blank');
    } catch (error) {
      console.error('Error generating PDF:', error);
    } finally {
      setLoader(false);
    }
  };

  

  useEffect(() => {
    if (formRef.current) {
      formRef.current.scrollTop = 0;
    }
  }, []);
const groupDatesByWeek = (weekData) => {
  const sortedDates = Object.keys(weekData).sort();
  const weeks = {};

  sortedDates.forEach(date => {
    const weekStart = dayjs(date).startOf("isoWeek").format("YYYY-MM-DD");
    const weekEnd = dayjs(date).endOf("isoWeek").format("YYYY-MM-DD");

    const key = `${weekStart}_${weekEnd}`;

    if (!weeks[key]) {
      weeks[key] = {
        start: weekStart,
        end: weekEnd,
        dates: []
      };
    }

    weeks[key].dates.push(date);
  });

  return Object.values(weeks);
};
const buildWeeks = (weekData) => {
  const dates = Object.keys(weekData)
    .filter(d => dayjs(d, "YYYY-MM-DD", true).isValid()) // ✅ remove bad dates
    .sort();

  if (!dates.length) return [];

  const weeks = {};

  dates.forEach(d => {
    const start = dayjs(d).startOf("isoWeek").format("YYYY-MM-DD");
    const end = dayjs(d).endOf("isoWeek").format("YYYY-MM-DD");
    const key = `${start}_${end}`;

    if (!weeks[key]) {
      const fullWeek = [];
      for (let i = 0; i < 7; i++) {
        fullWeek.push(dayjs(start).add(i, "day").format("YYYY-MM-DD"));
      }

      weeks[key] = {
        start,
        end,
        dates: fullWeek
      };
    }
  });

  return Object.values(weeks);
};

const weeklyTables = buildWeeks(weekData);
const weeklyGroups = groupDatesByWeek(weekData);


  const handleBackdropClick = (e) => {
    // Check if the click target is the backdrop itself (not the modal content)
    if (e.target === e.currentTarget) {
      setFormView(false);
    }
  };
  return (
    <div  onClick={handleBackdropClick} className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 ">
      <div className="relative w-full max-w-4xl  flex flex-col justify-center items-center p-6 bg-white rounded-lg border border-gray-300 shadow-md overflow-y-auto custom-scrollbar max-h-[95vh]">
        <div className="w-full flex justify-between items-end">
          <button
            onClick={generatePDF}
            className="bg-red-800 text-white px-4 py-1 rounded hover:bg-green-600"
          >
            Print
          </button>
          <button
            onClick={() => setFormView(false)}
            className="text-gray-600 hover:text-black"
          >
            <CloseIcon />
          </button>
        </div>

        <div ref={formRef} className="w-[90%] mt-4 mx-auto overflow-y-auto custom-scrollbar p-4">
          {/* Form Header */}
          <div className="border-b border-gray-700 pb-2 mb-4">
            <div className="flex w-full justify-between">
              <img src={NtactLogo} alt="NTACT Logo" />
              <div>
                <h2 className="text-lg font-semibold">WEEKLY DRIVER LOG & SAFETY</h2>
              </div>
              <div className="mr-24"></div>
            </div>
          </div>

          {employeeSections.map((section, sIndex) => (
          <div key={sIndex}>
            {isAllEmployees && sIndex > 0 && <hr className="border-t-4 border-[#1E4976] my-8" />}
            {isAllEmployees && (
              <div className="bg-[#1E4976] text-white px-4 py-3 rounded mb-4 text-lg font-semibold">
                {section.driverName} ({section.empId})
              </div>
            )}

            {/* Driver Info */}
            <div className="grid grid-cols-3 gap-4 mb-4">
              <div className="border border-[#9CA3AF] p-1">
                <p className="text-sm font-inter font-semibold text-left">Driver:</p>
                <p className="text-left font-inter p-1 px-2">{section.driverName}</p>
                <hr className="border-t border-[#9CA3AF]" />
              </div>
              <div className="border border-[#9CA3AF] p-1">
                <p className="text-sm font-inter font-semibold text-left">Unit #:</p>
                <p className="text-left font-inter p-1 px-2">{section.unitNumber}</p>
                <hr className="border-t border-[#9CA3AF]" />
              </div>
              <div className="border border-[#9CA3AF] p-1">
                <p className="text-sm font-inter font-semibold text-left">Date:</p>
                <p className="text-left font-inter p-1 px-2">{isAllEmployees ? section.dates : (rowData.json_data?.find(obj => obj.Dates)?.Dates || filledDate)}</p>
                <hr className="border-t border-[#9CA3AF]" />
              </div>
            </div>

            {/* Unit Info */}
            <div>
              {section.formsData.map((item, index) => (
                <div key={index} className="border text-start border-[#9CA3AF] p-2 mb-4">
                  <p className="text-xs text-gray-500">Date: {item.filledDate}</p>
                  <p className="text-sm font-semibold">Unit #:</p>
                  <p className="text-xs p-1 px-2">{item.unitNumber}</p>
                </div>
              ))}
            </div>

            {/* Log Table */}
            <div className="mb-4">
              <div className="overflow-x-auto">
                <table className="w-full border-collapse border border-gray-300">
                  <thead>
                    <tr className="bg-gray-200">
                      <th className="border border-gray-300 p-2 text-sm font-inter font-semibold">Date</th>
                      <th className="border border-gray-300 p-2 text-sm font-inter font-semibold">Mileage Start</th>
                      <th className="border border-gray-300 p-2 text-sm font-inter font-semibold">Mileage End</th>
                      <th className="border border-gray-300 p-2 text-sm font-inter font-semibold">Job #</th>
                      <th className="border border-gray-300 p-2 text-sm font-inter font-semibold">Repair/Fill-up Location</th>
                      <th className="border border-gray-300 p-2 text-sm font-inter font-semibold">Gallons Fuel</th>
                      <th className="border border-gray-300 p-2 text-sm font-inter font-semibold">Total Amount</th>
                      <th className="border border-gray-300 p-2 text-sm font-inter font-semibold">Mileage @ Repair/Fill-up</th>
                    </tr>
                  </thead>
                  <tbody>
                    {section.logData.length > 0 ? (
                      section.logData.map((log, index) => {
                        const cell = "border border-gray-300 p-2 text-sm font-inter text-center";
                        const isFirstOfDate = index === 0 || log.date !== section.logData[index - 1].date;
                        let sameDateCount = 0;
                        if (isFirstOfDate) {
                          for (let i = index; i < section.logData.length && section.logData[i].date === log.date; i++) {
                            sameDateCount++;
                          }
                        }
                        const muted = "border border-gray-300 p-2 text-sm font-inter text-center text-gray-400";
                        if (log.fuel_allocation === 'equipment') {
                          return (
                            <tr key={index}>
                              {isFirstOfDate && <td className={`${cell} align-middle`} rowSpan={sameDateCount}>{log.date}</td>}
                              {isFirstOfDate && <td className={`${cell} align-middle`} rowSpan={sameDateCount}>{log.mileage_start}</td>}
                              {isFirstOfDate && <td className={`${cell} align-middle`} rowSpan={sameDateCount}>{log.mileage_end}</td>}
                              <td className={muted}>—</td>
                              <td className={cell}>
                                <span className="inline-block text-[10px] font-semibold bg-amber-100 text-amber-700 rounded px-1 mr-1">Equipment</span>
                                {log.equipment_description || "—"}
                              </td>
                              <td className={cell}>{log.gallons_fuel}</td>
                              <td className={cell}>{log.total_amount}</td>
                              <td className={muted}>—</td>
                            </tr>
                          );
                        }
                        return (
                          <tr key={index}>
                            {isFirstOfDate && <td className={`${cell} align-middle`} rowSpan={sameDateCount}>{log.date}</td>}
                            {isFirstOfDate && <td className={`${cell} align-middle`} rowSpan={sameDateCount}>{log.mileage_start}</td>}
                            {isFirstOfDate && <td className={`${cell} align-middle`} rowSpan={sameDateCount}>{log.mileage_end}</td>}
                            <td className={cell}>{log.job_number}</td>
                            <td className={cell}>{log.repair_fillup_location}</td>
                            <td className={cell}>{log.gallons_fuel}</td>
                            <td className={cell}>{log.total_amount}</td>
                            <td className={cell}>{log.mileage_at_repair_fillup}</td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="8" className="border border-gray-300 p-2 text-sm font-inter text-center">No log data available</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Note Section */}
            <div className="mb-4 p-4 rounded border-t border-b" style={{ borderTop: "1px solid #FECACA", borderBottom: "1px solid #FECACA", background: "#FEF2F2" }}>
              <p className="text-sm font-inter text-left" style={{ color: "#DC2626" }}>
                NOTE: Seat belts shall be worn any time the vehicle is in motion. This log shall be kept current and turned in weekly.
              </p>
            </div>

            <div className="flex items-center font-semibold gap-2 my-1">
              {redcheck}
              <span>Vehicle Safety Check</span>
            </div>
            <div className="my-1 text-start">Check YES for good condition, NO if item requires attention (add comment)</div>

            {/* Safety Checklist */}
            <div className="mb-4">
              <div className="w-full">
                {section.weeklyTables.map((week, wIndex) => {
                  const fullWeekDates = week.dates;
                  return (
                    <div key={wIndex} className="mb-10">
                      <div className="font-semibold text-left mb-2">
                        Week: {dayjs(week.start).format("MMM DD")} - {dayjs(week.end).format("MMM DD, YYYY")}
                      </div>
                      <table className="min-w-full table-fixed border">
                        <thead>
                          <tr className="bg-gray-100">
                            <th className="px-4 py-2 text-left w-1/6">Vehicle Component</th>
                            {fullWeekDates.map((date) => (
                              <th key={date} className="px-2 py-2 text-center w-1/12">
                                <div>{dayjs(date).format("ddd")}</div>
                                <div>{dayjs(date).format("MM/DD")}</div>
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {VEHICLE_COMPONENTS_LIST.map((comp) => (
                            <tr key={comp} className="border-t">
                              <td className="px-4 py-2 font-medium w-1/6">{comp}</td>
                              {fullWeekDates.map((date) => {
                                const entryForDate = section.weekData[date]?.reduce((acc, obj) => ({ ...acc, ...obj }), {}) || {};
                                const val = entryForDate[comp] || "";
                                return (
                                  <td key={date + "-" + comp} className={`px-2 py-2 text-center font-bold w-1/12 ${val === "Y" ? "bg-green-50 text-green-600" : val === "N" ? "bg-red-50 text-red-600" : "text-gray-400"}`}>
                                    {val}
                                  </td>
                                );
                              })}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Comments Section */}
            <div className="mb-4">
              <div className="text-[16px] my-4 text-left font-semibold">COMMENTS (NOTE ANY ITEMS OR REPAIRS NEEDED)</div>
              {section.commentsData.length > 0 ? (
                section.commentsData.map((item, index) => (
                  <div key={index} className="border text-start border-[#9CA3AF] p-2 mb-3">
                    <div className="text-xs text-gray-500 mb-1">{dayjs(item.date).format("MMM DD, YYYY")}</div>
                    <p className="text-sm text-gray-700">{item.comment}</p>
                  </div>
                ))
              ) : (
                <div className="border border-[#9CA3AF] p-2 text-sm text-gray-500">No comments provided.</div>
              )}
            </div>
          </div>
          ))}
{/* Comment Images by Date */}
{Object.keys(imagesarray.commentImagesByDate || {}).length > 0 && (
  <div className="mb-4">
    <div className="text-[16px] my-4 text-left font-semibold">
      COMMENT IMAGES (BY DATE)
    </div>

    {Object.entries(imagesarray.commentImagesByDate).map(([date, imgs]) => (
      <div key={date} className="mb-6">
        <p className="font-semibold mb-2 text-left">
          {dayjs(date).format("MMM DD, YYYY")}
        </p>

        <div>
          <p className="text-sm font-semibold mb-2 text-start">Comment Images:</p>
          <div className="flex flex-wrap gap-4">
            {imgs.map((img, i) => (
              <div
                key={i}
                className="w-44 h-32 flex items-center justify-center border border-gray-300 rounded-lg shadow-md bg-white hover:shadow-lg transition-shadow"
              >
                <img
                  src={img.base64_data}
                  alt={`Comment Image ${i + 1}`}
                  className="w-40 h-24 object-contain"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    ))}
  </div>
)}

       {/* Signatures */}
<div className="grid grid-cols-2 gap-4">
  <div className="border border-[#9CA3AF] p-1">
    <p className="text-sm font-inter font-semibold text-left">Checked By:</p>
    <p className="text-left font-inter p-1 px-2">{checkedBy}</p>
    <hr className="border-t border-[#9CA3AF]" />
  </div>

  <div className="border border-[#9CA3AF] p-1">
    <p className="text-sm font-inter font-semibold text-left">Driver Signature:</p>

    {imagesarray?.driverSignature?.base64_data && (
      <img
        src={imagesarray.driverSignature.base64_data}
        alt="Driver Signature"
        className="w-40 h-24 object-contain border border-gray-300 rounded-md shadow-sm bg-white mt-2"
      />
    )}

    <hr className="border-t border-[#9CA3AF]" />
  </div>
</div>

          {/* DF Sign-Off Section */}
          {needsSignOff && (
            <div className="mt-6 border border-gray-300 rounded-lg p-4 bg-gray-50">
              <h3 className="text-md font-bold text-gray-800 mb-3">
                Driver Form Sign-Off
              </h3>
              <p className="text-xs text-gray-500 mb-4">
                This form requires sign-off because one or more Vehicle Safety Check items were marked "No".
              </p>

              {/* Show existing sign-offs */}
              {Object.keys(df_data).length > 0 && (
                <div className="grid grid-cols-1 gap-3 mb-4">
                  {Object.entries(df_data).map(([userId, entry]) => {
                    const entryName = typeof entry === 'object' ? entry?.name : '';
                    const preview = dfSignPreviews[userId];
                    const existingNotes = dfSignOffNotesFromServer[userId];

                    return (
                      <div key={userId} className="border border-[#9CA3AF] p-3 rounded-md bg-white">
                        <p className="text-sm font-semibold text-gray-800">
                          {entryName || `User #${userId}`}
                        </p>
                        <hr className="mt-2 mb-2" />
                        {preview && (
                          <>
                            <p className="text-sm font-semibold mt-1">Signature:</p>
                            <img src={preview} alt="DF Signature" className="w-40 h-24 object-contain border rounded mt-2" />
                          </>
                        )}
                        {existingNotes && (
                          <div className="mt-2">
                            <p className="text-xs font-semibold text-gray-600">Sign-off Notes:</p>
                            <p className="text-xs text-gray-700 whitespace-pre-wrap mt-1">{existingNotes}</p>
                          </div>
                        )}
                        <p className="text-xs text-green-600 font-semibold mt-2">&#10003; Signed Off</p>
                      </div>
                    );
                  })}
                </div>
              )}

              {/* Sign-off action — any N2 user who hasn't signed yet */}
              {hasN2 && !currentUserSigned && (
                <div className="border border-[#9CA3AF] p-3 rounded-md bg-white">
                  <p className="text-xs text-gray-600 mb-3">
                    Please review the safety check items and sign off.
                  </p>
                  <div className="mb-3">
                    <label className="text-xs font-semibold text-gray-600 block mb-1">Sign-off Notes (optional)</label>
                    <textarea
                      rows={3}
                      className="w-full border border-gray-300 rounded-md p-2 text-sm focus:outline-none focus:border-blue-500"
                      placeholder="Add any notes about this sign-off..."
                      value={dfSignOffNote}
                      onChange={(e) => setDfSignOffNote(e.target.value)}
                    />
                  </div>
                  <button
                    className="bg-[#2563EB] text-white text-sm px-4 py-2 rounded-md hover:bg-[#1E40AF] w-fit"
                    onClick={handleStartDfSignOff}
                  >
                    Sign Off
                  </button>
                </div>
              )}

              {!hasN2 && dfStatus === 'P' && Object.keys(df_data).length === 0 && (
                <p className="text-xs text-gray-500 italic">
                  Awaiting sign-off from authorized reviewer...
                </p>
              )}
            </div>
          )}

        </div>
      </div>
      <Backdrop
                    sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={loader}
                  >
                    <CircularProgress color="inherit" />
                  </Backdrop>
      <SignatureModal
        isModal={dfSignatureModalOpen}
        setModal={(open) => {
          setDfSignatureModalOpen(open);
          // modal closed — no cleanup needed
        }}
        onSave={handleDfSignatureCapture}
      />
    </div>
  );
};

export default WDSMergeFormModal;